var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2256 4.125C10.5626 4.125 4.35059 10.337 4.35059 18C4.35059 25.663 10.5626 31.875 18.2256 31.875C25.8885 31.875 32.1006 25.663 32.1006 18C32.1006 10.337 25.8885 4.125 18.2256 4.125ZM2.10059 18C2.10059 9.09441 9.31999 1.875 18.2256 1.875C27.1312 1.875 34.3506 9.09441 34.3506 18C34.3506 26.9056 27.1312 34.125 18.2256 34.125C9.31999 34.125 2.10059 26.9056 2.10059 18ZM18.2256 11.625C18.8469 11.625 19.3506 12.1287 19.3506 12.75V20.534L21.9301 17.9545C22.3694 17.5152 23.0817 17.5152 23.5211 17.9545C23.9604 18.3938 23.9604 19.1062 23.5211 19.5455L19.0211 24.0455C18.5817 24.4848 17.8694 24.4848 17.4301 24.0455L12.9301 19.5455C12.4908 19.1062 12.4908 18.3938 12.9301 17.9545C13.3694 17.5152 14.0817 17.5152 14.5211 17.9545L17.1006 20.534V12.75C17.1006 12.1287 17.6043 11.625 18.2256 11.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.8280f262744c53c6b057007dfc870178.svg";
export { ForwardRef as ReactComponent };